import { Modality, ActivityContent, ActivityReviews } from "./ActivityDetail";

export const QuestionFirstNamesExclude = [
  'FULL_NAMES_FIRST',
  'FIRST NAME',
];

export const QuestionLastNamesExclude = [
  'FULL_NAMES_LAST',
  'LAST NAME',
];

export const QuestionAgesExclude = [
  'AGE',
];

export const QuestionAgeBandsExclude = [
  'AGE_BAND',
  'AGEBAND',
  'AGE BAND',
];

export function isTravelerAgeBandQuestion(q: { code?: string; text?: string }): boolean {
  const c = (q.code || '').toUpperCase();
  if (QuestionAgeBandsExclude.includes(c)) return true;
  return (q.text || '').toLowerCase().includes('age band');
}

/** True when a question is the product’s date-of-birth field (e.g. code `DATE_OF_BIRTH` or "date of birth" text). */
export function isDateOfBirthQuestion(q: { code?: string; text?: string }): boolean {
  const c = (q.code || '').toUpperCase();
  if (c === 'DATE_OF_BIRTH') return true;
  return (q.text || '').toLowerCase().includes('date of birth');
}

export const QuestionCodesExclude = [
  ...QuestionFirstNamesExclude,
  ...QuestionLastNamesExclude,
  ...QuestionAgesExclude,
  ...QuestionAgeBandsExclude,
];

export interface ActivityAvailabilityResponse {
  errors: string[];
  activityCode: string;
  currency: string;
  sessionId: string;
  modalities: Modality[];
}

export interface IActivityAvailabilityHold {
  holdReference: string;
  availabilityExpiresAt: string;
  holdLimit: number;
}

export interface SessionKey {
  value: string;
  expireDate: string;
  isInvalid: boolean;
}

export interface Activity {
  code: string;
  name: string;
  currency: string;
  errors: string[];
  modalities: Modality[];
  content: ActivityContent;
  reviews: ActivityReviews;
}



export type DurationMetric = "HOURS" | "MINUTES" | "DAYS";

export interface Question {
  code: string;
  text: string;
  required: boolean;
  type: QuestionType;
  group: QuestionGroup;
  units?: QuestionUnit[];
  options: QuestionOption[];
}

export type QuestionType =
  | "STRING"
  | "TIME"
  | "DATE"
  | "NUMBER_AND_UNIT"
  | "LOCATION_REF_OR_FREE_TEXT";

export const QUESTION_GROUP_PER_BOOKING = 'PER_BOOKING';
export const QUESTION_GROUP_PER_PERSON = 'PER_PERSON';
export const QUESTION_GROUP_PER_TRAVELER = 'PER_TRAVELER';

export const QuestionGroupTraveler = [QUESTION_GROUP_PER_TRAVELER, QUESTION_GROUP_PER_PERSON];

export type QuestionGroup = "PER_BOOKING" | "PER_PERSON" | "PER_TRAVELER";

export type QuestionUnit =
  | "LOCATION_REFERENCE"
  | "FREETEXT";

export interface QuestionOption {
  code: string;
  text: string;
}



